module.exports = __webpack_public_path__ + "static/media/logo.97e8ad7a.png";